// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"7d0349ba","109":"ebab16cd","117":"66c8eb09","377":"fb469ee6","417":"c553a98e","427":"75c05452","973":"7b61594f"}[chunkId] + ".chunk.js";
};